function GetPaginateFunc(aUrl){
  return (aPage = 1, aLimit = 10, aId = 0, aSearch = '') => ({url: aUrl, params: {page: aPage, limit: aLimit, id: aId, search: aSearch}});
}


export default {
  GetPaginateFunc
}
